export default __webpack_public_path__ + "static/media/Insurance services.2dbba939.png";